import { render, staticRenderFns } from "./BedroomForm.vue?vue&type=template&id=741edfb5&"
import script from "./BedroomForm.vue?vue&type=script&lang=js&"
export * from "./BedroomForm.vue?vue&type=script&lang=js&"
import style0 from "./BedroomForm.vue?vue&type=style&index=0&id=741edfb5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports